import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Layer, Source } from 'react-mapbox-gl'
import isEqual from 'deep-equal'
import diff from '../utility/diff'
import { EXPLOITS_MARKERS } from '../config/services'
import { makeGetLayerRendered } from '../selectors/layerRenderedSelector'
import { makeGetPaint } from '../selectors/paintSelector'
import { makeGetDatetime } from '../selectors/datetimeSelector'
import DataActions from '../redux/dataRedux'
import { makeGetEventData } from '../selectors/eventDataSelector'
import { lime } from '@material-ui/core/colors'

const id = 'ChurchillMarkers'
const authId = 'RiverIce'
const sourceLayer = 'churchill-markers'
const HOVER_PROPERTY = 'Segment'
const LABEL_PROPERTY = 'Segment'
const SOURCE = ({ idToken, timeIso }) =>
  `https://coresight-vector.s3-us-west-2.amazonaws.com/churchill-markers/{z}/{x}/{y}.pbf`

const layout = {
  'line-cap': 'round'
}

export class ExploitsMarkers extends Component {
  componentDidMount() {
    const { map } = this.context
    if (!map) { return }
    map.on('mousemove', id, this.handleMouseMove)
  }

  componentWillUnmount() {
    const { map } = this.context
    if (!map) { return }
    map.off('mousemove', id, this.handleMouseMove)
  }

  handleMouseMove = event => {
    return
    const { map } = this.context
    const { actions, layerRendered } = this.props
    if (!layerRendered) {
      return
    }
    const features = map.queryRenderedFeatures(event.point, {
      layers: [id]
    })
    const data = features.map(feature => feature.properties)
    console.log(data)
    if (data) {
      actions.dataUpdated(data[0], 'hover')
    }
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.paint !== this.props.paint) {
      return false
    } else if (nextProps.hovered !== this.props.hovered) {
      return false
    } else if (nextProps === this.props) {
      return false
    }
    return true
  }

  static contextTypes = {
    map: PropTypes.object
  }

  componentWillReceiveProps(props) {
    const { paint, layout, before, layerOptions, hovered } = this.props
    const { map } = this.context

    if (!isEqual(props.paint, paint)) {
      const paintDiff = diff(paint, props.paint)

      Object.keys(paintDiff).forEach(key => {
        map.getLayer(id) && map.setPaintProperty(id, key, paintDiff[key])
      })
    }

    if (!isEqual(props.layout, layout)) {
      const layoutDiff = diff(layout, props.layout)

      Object.keys(layoutDiff).forEach(key => {
        map.getLayer(id) && map.setLayoutProperty(id, key, layoutDiff[key])
      })
    }

    if (!isEqual(props.hovered, hovered)) {
      if (hovered[HOVER_PROPERTY]) {
        const filter = ['in', HOVER_PROPERTY].concat(props.hovered[HOVER_PROPERTY])
        map.setFilter(`${id}Hovered`, filter)
      }
    }

    if (
      props.layerOptions &&
      layerOptions &&
      !isEqual(props.layerOptions.filter, layerOptions.filter)
    ) {
      map.setFilter(id, props.layerOptions.filter)
    }

    if (before !== props.before) {
      map.moveLayer(id, props.before)
    }
  }

  render() {
    const { idToken, layerRendered, paint, time } = this.props
    const visible = layerRendered

    const timeIso = time ? new Date(time).toISOString() : ''
    const vectorSource = {
      type: 'vector',
      tiles: [SOURCE({ idToken, timeIso })],
      tileSize: 512,
      maxzoom: 10
    }

    if (!visible) {
      return null
    }

    return (
      <div>
        <Source id={id} tileJsonSource={vectorSource} />
        <Layer
          type='line'
          id={id}
          sourceId={id}
          sourceLayer={sourceLayer}
          layout={layout}
          paint={paint}
        />
        <Layer
          type='symbol'
          id={`${id}Label`}
          sourceId={id}
          sourceLayer={sourceLayer}
          layout={{
            'text-field': ['concat', ['to-string', ['get', LABEL_PROPERTY]], ''],
            'text-size': 20,
            'text-offset': [
              'step',
              ['to-number', ['get', LABEL_PROPERTY]],
              ['literal', [-3.8, 1.8]],
              2, ['literal', [-6.5, 3]],
              3, ['literal', [-5.5, 4.5]],
              4, ['literal', [-0.1, 5.5]],
              5, ['literal', [2, 0]],
              6, ['literal', [3, 1.5]]
            ],
            'text-anchor': 'top'
          }}
          paint={{
            'text-color': lime[900]
          }}
        />
        <Layer
          id={`${id}Hovered`}
          type='line'
          sourceId={id}
          sourceLayer={sourceLayer}
          layout={layout}
          paint={{
            'line-color': lime[500],
            'line-width': 4
          }}
          filter={['in', HOVER_PROPERTY]}
        />
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  const getLayerRendered = makeGetLayerRendered()
  const getPaint = makeGetPaint()
  const getDatetime = makeGetDatetime()
  const getEventData = makeGetEventData()
  const mapStateToProps = state => {
    return {
      idToken: state.login.idToken,
      layerRendered: getLayerRendered(
        state,
        id,
        authId
      ),
      paint: getPaint(state, id),
      time: state.layer.times.WaterLakeTss || undefined,
      datetime: getDatetime(state, id) || '',
      hovered: getEventData(state, id)
    }
  }
  return mapStateToProps
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      dataUpdated: (json, event) =>
        dispatch(DataActions.dataFulfilled(json, id, event))
    }
  }
}

export default connect(makeMapStateToProps(), mapDispatchToProps)(ExploitsMarkers)



// WEBPACK FOOTER //
// ./src/layers/ChurchillMarkers.js